module.exports = __webpack_public_path__ + "static/media/flipVertical.da124b1d.svg";